import classes from "./style.module.css"

const BreadcrumbDivider = () => <div className={classes.divider} />

export default BreadcrumbDivider
